<div class="container">
    <div class="beginning-option-label">
        <div data-cy="vessel-modal-repurpose-header">
            {{ 'vessel.create.option.repurpose.label' | translate }}
        </div>
        <div class="info-wrapper">
            <mat-icon
                (click)="showInfoContainer = !showInfoContainer; $event.stopPropagation()"
                svgIcon="info"
                class="info-icon"
                data-cy="vessel-modal-repurpose-tooltip-icon" />
            <div class="info-container" *ngIf="showInfoContainer" #infoContainer>
                <div data-cy="vessel-modal-repurpose-tooltip-text1">
                    {{ 'vessel.create.option.repurpose.info.1' | translate }}
                </div>
                <div data-cy="vessel-modal-repurpose-tooltip-text2">
                    {{ 'vessel.create.option.repurpose.info.2' | translate }}
                </div>
                <div>
                    {{ 'vessel.create.option.repurpose.info.3' | translate }}
                </div>
            </div>
        </div>
    </div>
    <div>
        <app-input-select-with-error
            [initialValue]="selectedVessel ? selectedVessel : null"
            [placeholder]="'vessel.create.option.repurpose.vessel.placeholder'"
            [maxLength]="20"
            [legend]="'vessel.create.option.repurpose.vessel.placeholder'"
            [propertyName]="'vessel'"
            [optionsArray]="optionsObject"
            [displayKey]="'vesselName'"
            (onInputUpdated)="optionSelected($event)"
            [extraListInfo]="true"></app-input-select-with-error>
        <ng-container *ngIf="selectedOption && emptyVersionList">
            <div class="error-message" data-cy="vessel-modal-repurpose-no-previous-version-error">
                {{ 'vessel.create.option.repurpose.no-versions' | translate }}
            </div>
        </ng-container>
    </div>
    <div *ngIf="selectedOption">
        <ng-container *ngIf="loadingVersions; else versionSelector">
            <app-loading-spinner [smallSize]="true"></app-loading-spinner>
        </ng-container>
        <ng-template #versionSelector>
            <app-version-reference-page
                *ngIf="versionsList?.length > 0"
                [versions]="versionsList"
                [vessel]="selectedVessel"
                [referenceVersion]="compareVersion"
                [showHistoryButton]="false"
                (onReferenceSelected)="referenceSelected($event)"></app-version-reference-page>
        </ng-template>
    </div>
    <div *ngIf="compareVersion && !loadingVersions" class="version-history-button-wrapper">
        <div
            class="version-history-button"
            data-cy="vessel-modal-repurpose-version-history-btn"
            (click)="openVersionHistory()">
            {{ 'vessel.create.option.repurpose.history.button' | translate }}
        </div>
    </div>
</div>
